<template>
    <div
        class="modal items-center"
        :class="{'modal-open':visibleModal}"
    >
        <div class="modal-box w-[90%] sm:w-[24.75rem] rounded p-0 bg-transparent">
            <div class="max-h-[2.75rem] py-2.5 px-3 bg-error flex items-center rounded-t text-white">
                <div class="mr-2.5">
                    <SvgIcon
                        icon-name="message-alert"
                        class="w-6 h-6"
                    />
                </div>
                <div class="text-base xs:text-lg font-medium">
                    重要通知
                </div>
                <button
                    class="ml-auto"
                    @click="handleClose"
                >
                    <SvgIcon
                        icon-name="close"
                        class="w-5 h-5"
                    />
                </button>
            </div>
            <div class="overflow-auto max-h-[15.625rem] pad:min-h-[11.25rem] px-4 divide-y rounded-b bg-white">
                <div
                    v-for="(info, i) in noticeList"
                    :key="i"
                    class="collapse collapse-arrow"
                    :class="[currentCollapse === i?'collapse-open': 'collapse-close']"
                    @click="toggleCollapse(i)"
                >
                    <div class="collapse-title p-0 pr-5 my-2.5 h5 font-bold text-gray-900 break-all min-h-0 ">
                        {{ info.title }}
                    </div>
                    <div class="collapse-content px-0 h5 text-gray-700">
                        <p>
                            {{ info.body }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { watchEffect, ref, nextTick } from 'vue';
import { enableScroll, disableScroll } from '@/utils/style/fixedBodyScroll';

export default {
    props: {
        visibleModal: {
            type: Boolean,
            required: true
        },
        noticeList: {
            type: Array,
            default: () => []
        }
    },
    emits: ['update:visibleModal', 'handleClose'],
    setup(props, { emit }) {
        const currentCollapse = ref(0); // 預設第一個要開啟

        watchEffect(() => {
            if (props.visibleModal) {
                nextTick(() => {
                    disableScroll();
                });
            }
        });

        const handleClose = () => {
            emit('update:visibleModal', false);
            enableScroll();
        };

        const toggleCollapse = (i) => {
            currentCollapse.value = currentCollapse.value === i ? null : i;
        };
        return {
            currentCollapse,
            handleClose,
            toggleCollapse,
        };
    }
};
</script>

<style lang="scss" scoped>
.collapse-arrow .collapse-title:after {
    @apply right-1.5;
}
</style>
